import React from 'react';
import { Box, Typography } from '@mui/material';

import { ILocationScopedSettingsComponentProps } from './LocationScopedSettings';
import { ShopifySettingsCard } from './Integrations/Shopify/ShopifySettingsCard';

export const IntegrationsSettings: React.FC<ILocationScopedSettingsComponentProps> = ({
    settings,
    globalSettings,
    locationId,
    onSettingsSaved
}) => (
    <Box minWidth="500px">
        {locationId === undefined ? (
            <Typography variant="body2" color="textSecondary">
                N/A
            </Typography>
        ) : (
            <ShopifySettingsCard
                settings={settings}
                globalSettings={globalSettings}
                locationId={locationId}
                onSettingsSaved={onSettingsSaved}
            />
        )}
    </Box>
);
